<template>
  <div
    class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded"
    style="height: 450px; overflow: hidden;"
  >
    <div class="rounded-t mb-0 px-4 py-3 border-0">
      <div class="flex flex-wrap items-center">
        <div class="rounded-t mb-0 px-2 py-1 border-0">
          <h3 class="font-semibold text-base text-blueGray-700">
            프로젝트 일별 수집 현황
          </h3>
        </div>
      </div>
    </div>
    <div class="block w-full overflow-x-auto" style="max-height: 300px; overflow-y: auto;">
      <!-- Daily stats table -->
      <table class="items-center w-full bg-transparent border-collapse">
        <thead>
          <tr>
            <th
              class="px-6 bg-gray-100 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left"
            >
              일자
            </th>
            <th
              class="px-6 bg-gray-100 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-center"
            >
              언론
            </th>
            <th
              class="px-6 bg-gray-100 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-center"
            >
              블로그
            </th>
            <th
              class="px-6 bg-gray-100 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-center"
            >
              지식인
            </th>
            <th
              class="px-6 bg-gray-100 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-center"
            >
              카페
            </th>
            <th
              class="px-6 bg-gray-100 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-center"
            >
              커뮤니티
            </th>
            <th
              class="px-6 bg-gray-100 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-center"
            >
              유튜브
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(record, index) in paginatedData" :key="index" class="border-b border-blueGray-200 hover:bg-blueGray-50 transition-colors">
            <th
              class="px-6 align-middle text-xs whitespace-nowrap p-4 text-left font-bold text-blueGray-700"
            >
              {{ record.date }}
            </th>
            <td
              class="px-6 align-middle text-xs whitespace-nowrap p-4 text-center"
            > 
              <div class="font-semibold text-blueGray-600"><animated-number :value="record.press" />건</div> 
            </td>
            <td
              class="px-6 align-middle text-xs whitespace-nowrap p-4 text-center"
            > 
              <div class="font-semibold text-blueGray-600"><animated-number :value="record.blog" />건</div>  
            </td>
            <td
              class="px-6 align-middle text-xs whitespace-nowrap p-4 text-center"
            > 
              <div class="font-semibold text-blueGray-600"><animated-number :value="record.kin" />건</div>  
            </td>
            <td
              class="px-6 align-middle text-xs whitespace-nowrap p-4 text-center"
            > 
              <div class="font-semibold text-blueGray-600"><animated-number :value="record.cafe" />건</div>  
            </td>
            <td
              class="px-6 align-middle text-xs whitespace-nowrap p-4 text-center"
            >
              <div class="font-semibold text-blueGray-600"><animated-number :value="record.community" />건</div>  
            </td>
            <td
              class="px-6 align-middle text-xs whitespace-nowrap p-4 text-center"
            >
              <div class="font-semibold text-blueGray-600"><animated-number :value="record.youtube" />건</div>  
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="px-6 py-4 border-t border-blueGray-100">
      <div class="flex items-center justify-between">
        <div class="text-sm text-blueGray-500">
          {{ (currentPage - 1) * itemsPerPage + 1 }} - {{ Math.min(currentPage * itemsPerPage, dailyRecords.length) }} / 총 {{ dailyRecords.length }}건
        </div>
        <div class="flex gap-2">
          <button
            @click="goToPage(1)"
            :disabled="currentPage === 1"
            class="px-3 py-1 text-xs font-semibold rounded border transition-colors"
            :class="currentPage === 1 ? 'border-blueGray-200 text-blueGray-300 cursor-not-allowed' : 'border-blueGray-300 text-blueGray-600 hover:bg-blueGray-50'"
          >
            <i class="mdi mdi-chevron-double-left"></i>
          </button>
          <button
            @click="previousPage"
            :disabled="currentPage === 1"
            class="px-3 py-1 text-xs font-semibold rounded border transition-colors"
            :class="currentPage === 1 ? 'border-blueGray-200 text-blueGray-300 cursor-not-allowed' : 'border-blueGray-300 text-blueGray-600 hover:bg-blueGray-50'"
          >
            <i class="mdi mdi-chevron-left"></i>
          </button>
          <button
            v-for="page in displayedPages"
            :key="page"
            @click="goToPage(page)"
            class="px-3 py-1 text-xs font-semibold rounded border transition-colors"
            :class="currentPage === page ? 'bg-violet-500 border-violet-500 text-white' : 'border-blueGray-300 text-blueGray-600 hover:bg-blueGray-50'"
          >
            {{ page }}
          </button>
          <button
            @click="nextPage"
            :disabled="currentPage === totalPages"
            class="px-3 py-1 text-xs font-semibold rounded border transition-colors"
            :class="currentPage === totalPages ? 'border-blueGray-200 text-blueGray-300 cursor-not-allowed' : 'border-blueGray-300 text-blueGray-600 hover:bg-blueGray-50'"
          >
            <i class="mdi mdi-chevron-right"></i>
          </button>
          <button
            @click="goToPage(totalPages)"
            :disabled="currentPage === totalPages"
            class="px-3 py-1 text-xs font-semibold rounded border transition-colors"
            :class="currentPage === totalPages ? 'border-blueGray-200 text-blueGray-300 cursor-not-allowed' : 'border-blueGray-300 text-blueGray-600 hover:bg-blueGray-50'"
          >
            <i class="mdi mdi-chevron-double-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AnimatedNumber from '@/components/common/AnimatedNumber.vue';

export default {
  components: {
    AnimatedNumber
  },
  props: {
    projectDailyStats: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 5
    };
  },
  computed: {
    dailyRecords() {
      // Transform API data to component format
      return this.projectDailyStats.map(item => ({
        date: item.collection_date,
        press: Number(item.press_count) || 0,
        blog: Number(item.blog_count) || 0,
        kin: Number(item.kin_count) || 0,
        cafe: Number(item.cafe_count) || 0,
        community: Number(item.community_count) || 0,
        youtube: Number(item.youtube_count) || 0
      }));
    },
    totalPages() {
      return Math.ceil(this.dailyRecords.length / this.itemsPerPage);
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.dailyRecords.slice(start, end);
    },
    displayedPages() {
      const pages = [];
      const maxPagesToShow = 5;
      let startPage = Math.max(1, this.currentPage - Math.floor(maxPagesToShow / 2));
      let endPage = Math.min(this.totalPages, startPage + maxPagesToShow - 1);

      if (endPage - startPage < maxPagesToShow - 1) {
        startPage = Math.max(1, endPage - maxPagesToShow + 1);
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  methods: {
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    goToPage(page) {
      this.currentPage = page;
    }
  },
  watch: {
    projectDailyStats() {
      // Reset to first page when data changes
      this.currentPage = 1;
    }
  }
};
</script>
